import { CircleQuestionRegular } from '@allocab/allocab-icons';
import { useCallback, useState } from 'react';
import { twMerge } from 'tailwind-merge';

import { useOnClickOutside } from '../hooks/useOnClickOutside';

type Props = {
  text: string;
};

export const InfoPopover = ({ text }: Props) => {
  const [isVisible, setIsVisible] = useState(false);

  const ref = useOnClickOutside(
    useCallback(() => {
      setIsVisible(false);
    }, []),
  );

  return (
    <div className="relative">
      <CircleQuestionRegular
        width={16}
        height={16}
        onClick={() => setIsVisible(true)}
        className="cursor-pointer fill-current"
      />
      <div
        ref={ref}
        role="tooltip"
        className={twMerge(
          'absolute z-10 inline-block w-64 px-3 py-2 text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-lg shadow-sm dark:text-gray-400 dark:border-gray-600 dark:bg-gray-800',
          !isVisible && 'invisible opacity-0',
        )}
      >
        <p>{text}</p>
      </div>
    </div>
  );
};
